// @ts-nocheck
import React, { useState } from 'react';
import { CopyIcon, CheckIcon } from './icons';

const CodeBlock = ({ code, language, className = '', actions }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (_e) { /* ignore */ }
  };
  return (
    <div
      className={['relative', className].join(' ')}
      style={{
        background: 'var(--mov-paper-2)',
        border: '1px solid var(--mov-line)',
        borderRadius: 10,
        padding: '12px 14px',
      }}
    >
      <pre
        className="mov-mono m-0 overflow-x-auto"
        style={{ fontSize: 12, lineHeight: 1.6, color: 'var(--mov-ink)' }}
      >
        <code>{code}</code>
      </pre>
      <div className="absolute top-2 right-2 flex items-center gap-1">
        {language && (
          <span
            className="mov-mono"
            style={{ fontSize: 10, color: 'var(--mov-ink-mute)', letterSpacing: '0.08em', textTransform: 'uppercase' }}
          >
            {language}
          </span>
        )}
        {actions}
        <button
          type="button"
          onClick={copy}
          aria-label="Copy"
          className="grid place-items-center cursor-pointer"
          style={{
            width: 26, height: 26, borderRadius: 6,
            border: '1px solid var(--mov-line)',
            background: 'var(--mov-paper)',
            color: 'var(--mov-ink-soft)',
          }}
        >
          {copied ? <CheckIcon size={13} strokeWidth={2} /> : <CopyIcon size={13} />}
        </button>
      </div>
    </div>
  );
};

export default CodeBlock;
